export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/bac0a9e1413e9d32569d2cd2e44abe46.jpg"
          alt="Sell Tenant Occupied Real Estate El Paso"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Sell Tenant Occupied<br />Real Estate Fast
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          We Buy Rental Property with Tenants in Place • Cash Offers • Title Company Closings • Proven Track Record
        </p>
        
        {/* Key Benefits */}
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-money-dollar-circle-fill text-teal-400 text-2xl"></i>
            <span className="text-white font-semibold">Cash Offers</span>
          </div>
          <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-time-fill text-teal-400 text-2xl"></i>
            <span className="text-white font-semibold">Close in 7-14 Days</span>
          </div>
          <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-shield-check-fill text-teal-400 text-2xl"></i>
            <span className="text-white font-semibold">Title Company Protected</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href="tel:+1-915-206-5814"
            className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap inline-flex items-center justify-center"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call Now: (915) 206-5814
          </a>
          <a 
            href="#contact"
            className="bg-white hover:bg-gray-100 text-gray-900 px-8 py-4 rounded-lg text-lg font-bold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap inline-flex items-center justify-center"
          >
            <i className="ri-mail-fill mr-2"></i>
            Get Your Cash Offer
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-400 mb-2">200+</div>
            <div className="text-white text-lg">Rental Properties Purchased</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-400 mb-2">$120M+</div>
            <div className="text-white text-lg">Total Transaction Value</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-400 mb-2">100%</div>
            <div className="text-white text-lg">Title Company Closings</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}